//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { GameMode, MAX_MULTIPLIERS ,GameStatus , BetType  } from './enum';

export default {
  name: 'HomeActions',
  props: {
    settingsState: {
      type: Object,
      default: () => ({
        isSettingsTooltipOpen: false,
        disableAnimations: false,
        disableChickenRoadSounds: false,
        disableChickenRoadMusic: false
      })
    }
  },
  data() {
    return {
      howItWorksSlides: []
    };
  },
  methods: {
    async openHowGameWorksDialog() {
      this.$emit('open-how-game-works-dialog', {
        slides: this.howItWorksSlides
      });
    }
  }
};
